import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './mobile-device-util';
import AppMain from './app-main';

ReactDOM.render(
  <React.StrictMode>
    <AppMain />
  </React.StrictMode>,
  document.getElementById('root'),
);
